import './Services.css';
import React from "react";

const Services = () => {
  // Kerala Ayurvedic Massage Therapy - PRIMARY SERVICES
  const ayurvedicServices = [
    { name: 'Abhyanga (Full Body Massage)', icon: '🌿', description: 'Traditional Kerala full body massage with warm herbal oils for complete rejuvenation', price: '₹2000' },
    { name: 'Shirodhara', icon: '💧', description: 'Continuous stream of warm oil on forehead for deep relaxation and mental clarity', price: '₹2500' },
    { name: 'Pizhichil', icon: '✨', description: 'Royal treatment with warm medicated oil massage for stress relief and detoxification', price: '₹3500' },
    { name: 'Njavara Kizhi', icon: '🌾', description: 'Medicinal rice bolus massage for muscle strength and skin nourishment', price: '₹3000' },
    { name: 'Elakizhi', icon: '🍃', description: 'Herbal leaf bundle massage for pain relief and improved circulation', price: '₹2500' },
    { name: 'Podikizhi', icon: '🌿', description: 'Herbal powder massage for weight management and detoxification', price: '₹2500' },
    { name: 'Kativasti', icon: '💆', description: 'Lower back therapy with warm oil for back pain and spine health', price: '₹1800' },
    { name: 'Greeva Vasti', icon: '💆', description: 'Neck and shoulder therapy for cervical pain relief', price: '₹1500' },
    { name: 'Udvartana', icon: '✨', description: 'Herbal powder massage for weight loss and skin toning', price: '₹2000' },
    { name: 'Nasyam', icon: '🌸', description: 'Nasal therapy for sinus relief and respiratory health', price: '₹1200' },
    { name: 'Thalapothichil', icon: '🌿', description: 'Medicated paste application on head for mental relaxation', price: '₹1500' },
    { name: 'Ayurvedic Facial', icon: '💆', description: 'Natural herbal facial for glowing and healthy skin', price: '₹1800' }
  ];

  const hairServices = [
    { name: 'Hair Wash (Men)', icon: '🚿', description: 'Professional hair wash', price: '₹50' },
    { name: 'Hair Cut Kids (Men)', icon: '✂️', description: 'Haircut for kids', price: '₹150' },
    { name: 'Hair Cut Adults (Men)', icon: '✂️', description: 'Professional mens haircut', price: '₹200' },
    { name: 'Hair Spa (Men)', icon: '💆‍♂️', description: 'Deep conditioning hair spa', price: '₹500' },
    { name: 'Keratin Spa (Men)', icon: '💆‍♂️', description: 'Keratin nourishing spa', price: '₹800' },
    { name: 'Hair Straightening (Men)', icon: '💇‍♂️', description: 'Hair straightening treatment', price: '₹1500 / onwards' },
    { name: 'Keratin Treatment (Men)', icon: '✨', description: 'Keratin smoothing treatment', price: '₹2500' },
    { name: 'Hair Oil Massage (Men)', icon: '💆‍♂️', description: 'Relaxing oil head massage', price: '₹500' },
    { name: 'Hair Wash (Women)', icon: '🚿', description: 'Professional hair wash', price: '₹250' },
    { name: 'Hair Cut (Women)', icon: '✂️', description: 'Professional haircut', price: '₹300' },
    { name: 'Hair Cut Kids (Women)', icon: '✂️', description: 'Kids haircut', price: '₹200 / onwards' },
    { name: 'Stylish Cut', icon: '💇‍♀️', description: 'Trendy stylish haircut', price: '₹500' },
    { name: 'Hair Spa (Normal)', icon: '💆‍♀️', description: 'Normal hair spa treatment', price: '₹800' },
    { name: 'Keratin Spa (Women)', icon: '💆‍♀️', description: 'Keratin spa treatment', price: '₹1500' },
    { name: 'Loreal Spa', icon: '💆‍♀️', description: 'Loreal professional spa', price: '₹1000' },
    { name: 'Temporary Straightening', icon: '💇‍♀️', description: 'Temporary straight styling', price: '₹500' },
    { name: 'Temporary Curling', icon: '💇‍♀️', description: 'Temporary curling styling', price: '₹700' },
    { name: 'Hair Straightening (Women)', icon: '💇‍♀️', description: 'Permanent straightening', price: '₹3000' },
    { name: 'Smoothening', icon: '💇‍♀️', description: 'Frizz-free smooth hair treatment', price: '₹3500' },
    { name: 'Rebonding', icon: '💇‍♀️', description: 'Permanent hair rebonding', price: '₹3800' },
    { name: 'Kera Smoothening', icon: '✨', description: 'Keratin smoothening treatment', price: '₹4500' },
    { name: 'Smartbond', icon: '✨', description: 'Hair strengthening treatment', price: '₹1800' },
    { name: 'Botox Treatment', icon: '✨', description: 'Hair botox treatment', price: '₹5000' },
    { name: 'Nano Plastia', icon: '✨', description: 'Nano plastia hair treatment', price: '₹6000' },
    { name: 'Natural Colour', icon: '🎨', description: 'Natural hair colouring', price: '₹800' },
    { name: 'Colours', icon: '🎨', description: 'Premium hair colouring', price: '₹1200' },
    { name: 'Inoa Free Natural Colour', icon: '🎨', description: 'Ammonia-free natural colour', price: '₹1000' },
    { name: 'Root Touch Up', icon: '🎨', description: 'Root colour touch up', price: '₹1000' },
    { name: 'Inoa Root Touch Up', icon: '🎨', description: 'Inoa root touch up', price: '₹1200' },
    { name: 'Global Colour', icon: '🎨', description: 'Full hair global colour', price: '₹3000' },
    { name: 'Global Highlights', icon: '✨', description: 'Full hair highlights', price: '₹2500' },
    { name: 'Highlights (Per Strip)', icon: '✨', description: 'Per strip highlight', price: '₹200' },
    { name: 'Balayage Colour', icon: '🎨', description: 'Balayage colouring technique', price: '₹3500' },
    { name: 'Ombre Colour', icon: '🎨', description: 'Ombre colour styling', price: '₹2500' },
    { name: 'Shaving', icon: '🪒', description: 'Clean shaving service', price: '₹150' },
    { name: 'Setting Shaving', icon: '🧔', description: 'Beard setting and shaping', price: '₹100' }
  ];

  const skinServices = [
    { name: 'De-Tan Cleanup', icon: '✨', description: 'Removes tan and brightens skin', price: '₹800' },
    { name: 'Cleanup (Women)', icon: '✨', description: 'Deep cleansing facial', price: '₹800' },
    { name: 'Lotus Cleanup', icon: '🌸', description: 'Lotus herbal cleanup', price: '₹1000' },
    { name: 'Facial (Women)', icon: '💆‍♀️', description: 'Complete facial treatment', price: '₹1200' },
    { name: 'Lotus Facial', icon: '🌸', description: 'Premium lotus facial', price: '₹1500' },
    { name: 'Hydra Facial', icon: '💧', description: 'Hydrating facial treatment', price: '₹3000' },
    { name: 'Gold Sheen Facial', icon: '✨', description: 'Gold facial glow treatment', price: '₹2500' }
  ];

  const beautyServices = [
    { name: 'Manicure', icon: '💅', description: 'Basic manicure treatment', price: '₹500' },
    { name: 'Pedicure', icon: '🦶', description: 'Basic pedicure treatment', price: '₹1000' },
    { name: 'Underarm Honey Wax', icon: '🧴', description: 'Honey wax for underarms', price: '₹150' },
    { name: 'Full Arms Honey Wax', icon: '🧴', description: 'Full arms honey wax', price: '₹600' },
    { name: 'Legs Honey Wax', icon: '🧴', description: 'Legs honey wax', price: '₹500' },
    { name: 'Nose Piercing', icon: '💎', description: 'Professional nose piercing', price: '₹250' }
  ];

  const ayurvedaServices = [
  {
    name: 'Ayurvedic Massage',
    icon: '🌿',
    description:
      'Traditional Kerala massage therapy with warm herbal oils for complete body rejuvenation and stress relief'
  },
  {
    name: 'Detoxification Therapy',
    icon: '💆',
    description:
      'Deep cleansing treatments using natural herbs to eliminate toxins and restore body balance'
  },
  {
    name: 'Stress Relief Treatment',
    icon: '🧘',
    description:
      'Specialized massage techniques for deep relaxation, mental clarity, and emotional well-being'
  },
  {
    name: 'Holistic Healing',
    icon: '✨',
    description:
      'Complete wellness programs combining ancient Ayurvedic wisdom with modern therapeutic practices'
  }
];

  return (
    <div className="services">
      <section className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Our Services</h1>
          <p>Professional salon services with premium quality</p>
        </div>
      </section>

      <div className="services-container">
        {/* Kerala Ayurvedic Massage Therapy - PRIMARY SECTION */}
        <div className="service-category featured-category">
          <div className="category-header">
            <div className="featured-badge">Our Specialization</div>
            <div className="category-icon">🌿</div>
            <h2 className="category-title">Kerala Ayurvedic Massage Therapy</h2>
            <p className="category-description">
              Authentic traditional Kerala Ayurvedic treatments using pure natural herbal oils. 
              Experience ancient healing wisdom for stress relief, detoxification, and holistic wellness.
            </p>
          </div>
          <div className="services-grid featured-grid">
            {ayurvedicServices.map((service, index) => (
              <div key={index} className="service-item featured-service">
                <div className="service-icon-large">{service.icon}</div>
                <h3>{service.name}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-price">{service.price}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Hair Services */}
        <div className="service-category">
          <div className="category-header">
            <div className="category-icon">💇</div>
            <h2 className="category-title">Hair Services</h2>
            <p className="category-description">
              Professional hair care services for men, women, and kids
            </p>
          </div>
          <div className="services-grid">
            {hairServices.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon-large">{service.icon}</div>
                <h3>{service.name}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-price">{service.price}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="service-category">
          <div className="category-header">
            <div className="category-icon">💆</div>
            <h2 className="category-title">Skin & Facial Services</h2>
            <p className="category-description">
              Rejuvenating facial treatments for healthy, glowing skin
            </p>
          </div>
          <div className="services-grid">
            {skinServices.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon-large">{service.icon}</div>
                <h3>{service.name}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-price">{service.price}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="service-category">
          <div className="category-header">
            <div className="category-icon">💅</div>
            <h2 className="category-title">Beauty Services</h2>
            <p className="category-description">
              Complete beauty solutions for head-to-toe pampering
            </p>
          </div>
          <div className="services-grid">
            {beautyServices.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon-large">{service.icon}</div>
                <h3>{service.name}</h3>
                <p className="service-description">{service.description}</p>
                <div className="service-price">{service.price}</div>
              </div>
            ))}
          </div>
        </div>

          <div className="service-category">
            <div className="category-header">
            <div className="category-icon">🌿</div>
            <h2 className="category-title">Kerala Ayurvedic Massage Therapy</h2>
            <p className="category-description">
              Authentic traditional body massage treatments using pure natural herbal oils for holistic healing
            </p>
          </div>

          <div className="services-grid">
            {ayurvedaServices.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon-large">{service.icon}</div>
                <h3>{service.name}</h3>
                <p className="service-description">{service.description}</p>
                <a href="#" className="learn-more">Learn More →</a>
              </div>
            ))}
          </div>
        </div>

      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Book Your Service?</h2>
          <p>Booking Available via Phone & WhatsApp • Advance Appointment Recommended</p>
          <div className="cta-buttons">
            <a href="tel:+919876543210" className="cta-button">Call Now</a>
            <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="cta-button">WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
